<script setup>
/*
* This is a simple input component that can be used in forms.
* It accepts a label, error message, input ID, input type, and whether the input is required.
* The input is styled with Tailwind CSS.
* When an error is present, a red border is displayed around the input and a red exclamation triangle is displayed to the right of the input.
*
* @param {String} label - The label for the input.
* @param {String} error - The error message to display.
* @param {String} inputId - The ID for the input.
* @param {String} type - The type of input.
* @param {Boolean} required - Whether the input is required.
*/


import { ref, watch } from 'vue';

const model = defineModel();

const props = defineProps({
    label: String,
    error: String,
    form: Object,
    inputId: String,
    placeholder: {
        type: String,
        default: null,
    },
    type: {
        type: String,
        default: 'text',
    },
    required: {
        type: Boolean,
        default: false,
    },
    maxLength: {
        type: Number,
        default: 255,
    }
});

const input = ref(null);

//if error is present, focus on the input
watch(() => props.error, (value) => {
    error.value = value;
}, { deep: true });

const error = ref(props.error);

</script>

<template>


    <font-awesome-icon v-if="type == 'email'" :icon="['far', 'envelope']"
        class="absolute pointer-events-none left-3 top-1/2 transform -translate-y-1/2" aria-hidden="true" />

    <font-awesome-icon v-if="type == 'tel'" :icon="['far', 'phone']"
        class="absolute pointer-events-none left-3 top-1/2 transform -translate-y-1/2" aria-hidden="true" />

    <input v-model="model" ref="input" :id="inputId" :type="type" :autocomplete="inputId" :name="inputId" :class="[error ? '!ring-red-500 pr-8' : '',
    type == 'email' ? 'pl-9' : '',
    type == 'tel' ? 'pl-9' : '']" :maxlength="maxLength" :required="required" :placeholder="placeholder"
        class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:!ring-tan sm:text-sm sm:leading-6 duration-200" />

    <font-awesome-icon v-if="error" :icon="['far', 'triangle-exclamation']"
        class="absolute pointer-events-none right-3 top-1/2 transform -translate-y-1/2 text-red-500"
        aria-hidden="true" />

</template>
